<template lang="pug">
  v-select.timezone-select(:value.sync="selectedOption" @input="onInput" :options="options" placeholder="Select Timezone" label="name")
</template>
<script>

import vSelect from 'vue-select'
import timezones from '@/data/components/common/timezones'

export default {
  name: 'TimezonePicker',
  props: {
    value: {
      type: null
    }
  },
  data() {
    return {
      options: [],
      selectedOption: null
    }
  },
  created() {
    this.options = timezones
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    }
  },
  watch: {
    optionsValue() {
      if (this.optionsValue) {
        this.selectedOption = this.options.find((o) => o.value === this.value)
      }
    }
  },
  computed: {
    optionsValue() {
      if (this.value && this.options.length) {
        return true
      }
      return null
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/TimezonePicker.vue